// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1hNt-","tab":"ProcedureTabs_tab__3V3Xs"};